var map = {
	"./0-icon.png": 129,
	"./arrow-down-blue.svg": 1048,
	"./arrow-down-grey.svg": 1049,
	"./arrow-right-white.png": 1050,
	"./arrow-right.svg": 1051,
	"./avax-logo.png": 128,
	"./big_unicorn.png": 1052,
	"./binance-coin-logo.webp": 250,
	"./binance-logo.png": 189,
	"./blue-loader.svg": 49,
	"./busd-logo.png": 252,
	"./circle-grey.svg": 194,
	"./circle.svg": 195,
	"./coinbaseWalletIcon.svg": 190,
	"./coingecko.png": 1053,
	"./coinmarketcap.png": 1054,
	"./crosschain/BIOS.png": 330,
	"./crosschain/GDL.png": 258,
	"./crosschain/GROW.png": 332,
	"./crosschain/INDA.png": 256,
	"./crosschain/WAS.jpeg": 257,
	"./crosschain/WISB.png": 266,
	"./crosschain/XIOT.png": 331,
	"./crosschain/wBTC.png": 251,
	"./crosschain/wDAI.png": 253,
	"./crosschain/wETH.png": 1055,
	"./crosschain/wUSDC.png": 259,
	"./crosschain/wUSDT.png": 260,
	"./crosschain/zBTC.png": 261,
	"./crosschain/zDAI.png": 262,
	"./crosschain/zETH.png": 263,
	"./crosschain/zUSDC.png": 264,
	"./crosschain/zUSDT.png": 265,
	"./dropdown-blue.svg": 1056,
	"./dropdown-white-select.svg": 1057,
	"./dropdown.svg": 1058,
	"./dropup-blue.svg": 1059,
	"./ethereum-logo.png": 96,
	"./fortmaticIcon.png": 191,
	"./heco-icon.jpg": 334,
	"./ht.png": 162,
	"./link.svg": 1060,
	"./logo-text-white.png": 1061,
	"./logo-zero-124.png": 1062,
	"./logo-zero-512.png": 1063,
	"./magnifying-glass.svg": 1064,
	"./matic-logo.png": 187,
	"./menu.svg": 1065,
	"./metamask-icon.svg": 1066,
	"./metamask.png": 337,
	"./mountain.png": 1067,
	"./mountain_wide.png": 1068,
	"./noise.png": 1069,
	"./outside-link.svg": 1070,
	"./plus-blue.svg": 1071,
	"./plus-grey.svg": 1072,
	"./polkadot-logo.png": 335,
	"./polygon-logo.png": 336,
	"./portisIcon.png": 192,
	"./question-mark.svg": 1073,
	"./question.svg": 1074,
	"./small-dropdown-white-select.svg": 1075,
	"./space-background.jpg": 1076,
	"./space-bg.png": 1077,
	"./spinner.svg": 1078,
	"./sushi-logo.png": 254,
	"./token-list/lists-dark.png": 1079,
	"./token-list/lists-light.png": 1080,
	"./token-logo.png": 145,
	"./trustWallet.png": 1081,
	"./uni-logo.png": 255,
	"./walletConnectIcon.svg": 193,
	"./x.svg": 1082,
	"./xl_uni.png": 1083,
	"./zero-logo-text.png": 338
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 318;